(function ($) {
    "use strict";

    // Partie filtre

    var wpBlockLoader = $('<div class="wp-block-loader"><div></div><div></div><div></div><div></div></div>');


    $('#filters-reset').on(
        'click',
        function (e) {
            e.preventDefault();
            if ($('#filters').length > 0) {
                $('#filters')[0].reset();
            }
            if ($('#directory_filter').length > 0) {
                $('#directory_filter')[0].reset();
            }
            $('.dropdown .wp-block-alert').removeClass('unselectAll');
            $('.dropdown .wp-block-alert').html('Tout sélectionner');
            $('.dropdown-toggle').removeClass('itemSelected');
            $('.countdown-number').html(0);
            $('.dropdown-toggle').removeClass('itemSelected');
        }
    );

    $('.advanced-search-action').on(
        'click',
        function (e) {
            e.preventDefault();
            $('.simple-search').prop(
                'disabled',
                function (i, v) {
                    return !v;
                }
            );
            $(this).toggleClass('active');
            $('.advanced-search').slideToggle();
        }
    );

    var data = {
        tax: {}
    };

    function format_tax(tax_name, data_selected) {
        data.tax[tax_name] = [];

        $.each(
            data_selected,
            function (key, item) {
                item = $(item).val();
                if ('' != item) {
                    data.tax[tax_name].push(item);
                }
            }
        );
    }

    if ($('#orderby-select').length > 0) {
        $('#orderby-select').on('change', function () {
            goAjaxRefacto(1);
        });
    }

    if ($('.page-template-template-expert_directory #filters').length > 0) {

        function goAjaxFilterUser(paged = 1) {
            $.ajax(
                {
                    url: OMBREE_INFO.ajax,
                    type: "POST",
                    data: {
                        action: 'filter_user_expert',
                        search: $('[name="search"]').val(),
                        thematiques: $('#select-thematiques').val(),
                        territoire: $.map(
                            $('[name="territoires[]"]:checked'),
                            function (c) {
                                return c.value;
                            }
                        ),
                        base: window.location.origin + window.location.pathname,
                        nonce: OMBREE_INFO.nonce_user,
                        paged: paged,
                    }
                }
            ).done(
                function (response) {
                    $('.wp-block-expert-directory').html(response.html);

                }
            ).always(
                function () {
                    // $('.wp-block-loader').remove();
                    // $this.prop('disabled', false);
                }
            );
        }

    }

    function set_params_form() {

        var territoires = $('[name="territoires[]"]:checked').get(),
            thematiques = $('[name="thematiques[]"]:checked').get(),
            formats = $('[name="formats[]"]:checked').get(),
            search = $('[name="search"]').val();

        if ('' != search) {
            data.search = search;
        }
        if (territoires.length > 0) {
            format_tax('territoire', territoires);
        }
        if (thematiques.length > 0) {
            format_tax('thematique', thematiques);
        }
        if (formats.length > 0) {
            format_tax('format', formats);
        }

        if ($('#orderby-select').length > 0) {
            data.date_order = $('#orderby-select').val();
        }

        data.base = window.location.origin + window.location.pathname;
    }

    function goAjaxRefacto(newPaged = 1, typeFiltre = 'default', route = 'results') {

        $('#count_ressources').hide();

        
        $('.wp-block-search form').parent('.wp-block-search').after($(wpBlockLoader));

        data = {
            tax: {}
        };
        data.type_filtre = typeFiltre;
        data.paged = newPaged;
        if ('default' == typeFiltre) {
            if (1 == $("input[name='document_access']:checked").val()) {
                data.document_access = 1;
            } else {
                delete data.document_access;
            }
        }

        if (route == 'results_count') {
            data.only_count = 1;
        }

        // configure correctement les data
        set_params_form();


        $.ajax(
            {
                url: OMBREE_INFO.api_url + '/' + route,
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(data),
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
                },
            }
        ).done(
            function (response) {
              /*  if (route == 'results_count') {
                    $('#count_ressources').html(response.html);
                    $('#count_ressources').show();
                } else {*/

                    if ('directory_filter' == typeFiltre) {
                        $('[class ^=wp-block][class $=-directory]').remove();

                        if (response.html != null) {
                            var expert_count = $(response.html).find('.expert').length;
                            $('#count_ressources').text(expert_count + ' résultat' + (expert_count > 1 ? 's' : ''));
                            $('#count_ressources').show();
                            $('.wp-block-search').after(response.html);
                        }
                        if (response.html_error != null) {
                            $('.noresults-message').css('display', 'block');
                            $('.noresults-message').html(response.html_error);
                        } else {
                            $('.noresults-message').css('display', 'none');
                        }

                    }
                    if ('default' == typeFiltre) {

                        $('#count_ressources').html(response.count);
                        $('#count_ressources').show();
                        $('#results-query-items').html(response.html);
                    }
                    if ('remove_ressource' == typeFiltre) {
                        $('#result-request-delete').remove();
                        $('.page-template-template-remove_ressource .wp-block-table').remove();
                        $('.page-template-template-remove_ressource .pagination').remove();
                        $('.page-template-template-remove_ressource .wp-block-search').after(response.html);

                        //    $('.page-template-template-remove_ressource tbody').html(response.html);
                    }
              //  }
            }
        ).always(
            function () {
                $('.wp-block-loader').remove();
            }
        );
    }

    // request delete ressource partenaire
    if ($('.page-template-template-remove_ressource #filters').length > 0) {

        $('.page-template-template-remove_ressource #main').on(
            'click',
            '.request-delete',
            function (e) {
                e.preventDefault();

                if (window.confirm("Êtes vous certain de vouloir faire une demande de suppression ?")) {
                    var $this = $(this),
                        item = $this.data('item');

                    if ('' == item) {
                        return false;
                    }

                    $.ajax(
                        {
                            url: OMBREE_INFO.api_url + '/request_delete/partners',
                            type: "POST",
                            data: {
                                item: parseInt(item),
                            },
                            beforeSend: function (xhr) {
                                xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
                            },
                        }
                    ).done(
                        function (response) {
                            $this.parents('td').html(response.html);

                            $this.parents('.wp-block-buttons').remove();

                        }
                    ).always(
                        function () {
                            // $('.wp-block-loader').remove();
                            // $this.prop('disabled', false);
                        }
                    );

                }

            }
        );

    }

    // assignement partenaires
    if ($('.ressource__partner').length > 0) {

        function assignement_partner(route) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const item = urlParams.get('item');
            if (item == null) {
                return false;
            }
            $.ajax(
                {
                    url: OMBREE_INFO.api_url + '/' + route,
                    type: "POST",
                    data: {
                        item: parseInt(item),
                    },
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
                    },
                }
            ).done(
                function (response) {
                    $('.ressource__partner').html(response.html);
                }
            ).always(
                function () {
                    // $('.wp-block-loader').remove();
                    // $this.prop('disabled', false);
                }
            );
        }

        $('.ressource__partner').on(
            'click',
            '.unassign, .assignment',
            function (e) {
                e.preventDefault();
                var assignment_or_unassign = 'unassign';
                if ($(this).hasClass('assignment')) {
                    assignment_or_unassign = 'assign';
                }
                assignement_partner(assignment_or_unassign);
            }
        );
    }

    // filter requests partenaires et experts
    if ($('#requests-filter').length > 0) {
        $('#requests-filter').on(
            'submit',
            function () {
                $('#requests-filter input[type="submit"]').prop('disabled', true);
                var data = {
                    'status': $('#orderby-select').val()
                };
                $('#requests-filter').parent('.wp-block-filters').after(wpBlockLoader);

                var typeFilter = $('#requests-filter').data('type');

                if (typeof typeFilter == undefined || '' == typeFilter) {
                    return false;
                }

                var route_default = 'partners';

                if ('expert_directory' == typeFilter) {
                    route_default = 'experts';
                }

                $.ajax(
                    {
                        url: OMBREE_INFO.api_url + '/requests/' + route_default,
                        type: "POST",
                        contentType: "application/json",
                        data: JSON.stringify(data),
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
                        },
                    }
                ).done(
                    function (response) {
                        if (response.html != null) {
                            $('.wp-block-table').css('display', 'block');
                            $('#requests-filter').parents('.wysiwyg').find('tbody').html(response.html);
                        } else {
                            $('.wp-block-table').css('display', 'none');
                        }
                        if (response.html_error != null) {
                            $('.noresults-message').css('display', 'block');
                            $('.noresults-message').html(response.html_error);
                        } else {
                            $('.noresults-message').css('display', 'none');
                        }
                    }
                ).always(
                    function () {
                        $('.wp-block-loader').remove();
                        $('#requests-filter input[type="submit"]').prop('disabled', false)
                    }
                );

                return false;
            }
        );
    }

    // filter annuaires partenaires et experts
    if ($('#directory_filter').length > 0) {

        $('#directory_filter').on(
            'change',
            function (e) {
                e.preventDefault();
                var typfeFiler = $('#directory_filter').attr('class');

                if ('' != typfeFiler) {
                    var route = 'partners';
                    if ('expert_directory' == typfeFiler) {
                        route = 'experts';
                    }

                    goAjaxRefacto(1, 'directory_filter', 'directory/' + route);
                }

                return false;
            }
        );

        $('#directory_filter').parents('.wysiwyg').on(
            'click',
            '.pagination a.page-numbers',
            function (e) {
                e.preventDefault();
                var paged = $(this).attr('href').split('page/');

                paged = $(paged).get(-1).match(/\d+/); // on récupère le dernier élément du tableau et uniquement les chiffres

                paged = paged != null ? paged[0] : 1;

                var typfeFiler = $('#directory_filter').attr('class');

                if ('' != typfeFiler) {
                    var route = 'partners';
                    if ('expert_directory' == typfeFiler) {
                        route = 'experts';
                    }

                    goAjaxRefacto(paged, 'directory_filter', 'directory/' + route);
                }

            }
        );


    }

    // filter ressources
    if ($('#filters').length > 0) {

        $('#filters').on('change', function () {
            var typfeFiler = $(this).attr('class');
            goAjaxRefacto(1, typfeFiler );
            return false;
        });

        $('#filters .wp-block-alert').on('click', function (){
            var typfeFiler = $('#filters').attr('class');
            // on va attendre 200 milisecondes pour lancer le call
            // obliger d'attendre un peu car les éléments cochés dépendent du code de Simon (au click également)
            // sans le mini délay on n'a pas le bon résultat
            setTimeout(
                function()
                {
                    goAjaxRefacto(1, typfeFiler);
                }, 200);


            return false;
        })


        $('#filters').on(
            'submit',
            function (e) {
                //e.preventDefault();
                var typfeFiler = $(this).attr('class');
                goAjaxRefacto(1, typfeFiler);
                return false;
            }
        );

        $('#main').on(
            'click',
            '.pagination a.page-numbers',
            function (e) {
                e.preventDefault();
                var paged = $(this).attr('href').split('page/');

                paged = $(paged).get(-1).match(/\d+/); // on récupère le dernier élément du tableau et uniquement les chiffres

                paged = paged != null ? paged[0] : 1;
                var typfeFiler = $(this).parents('.pagination').data('type');

                goAjaxRefacto(paged, typfeFiler);
            }
        );
    }

    function ajax_vote(data, route_vote) {
        $('.wp-block-ressources-vote button').prop('disabled', true);
    
        $('.wp-block-ressources-vote').append(wpBlockLoader);
    
        $.ajax({
            url: OMBREE_INFO.api_url + '/vote/' + route_vote,
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
            },
        }).done(function (response) {
    
            if (response.html_error != '') {
                $('.wp-block-vote').css({color: "#c03"}).text(response.html_error);
                return;
            }
    
            if (response.vote != '') {
                $('.wp-block-vote').removeAttr('style');
                $('.wp-block-vote-results .block-vote-results__for.result span').text(response.vote.good)
                $('.is-style-vote').parent().remove();
                $('.wp-block-vote span').text(response.html);
                $('.wp-block-vote').show();
    
                // Send notification email to all users with the 'partner_role'
                var post_id = $('.wp-block-ressources').data('post-id');
                var data = {
                    'action': 'who_send_notification_email',
                    'post_id': post_id,
                    'vote': response.vote
                };
                $.post(OMBREE_INFO.ajax_url, data);
            }
    
            if (response.comments != '') {
                $('.wp-block-comments').remove();
                $('.wp-block-comment-form').after(response.comments);
            }
    
        }).always(function () {
            $('.wp-block-loader').remove();
            $('.wp-block-ressources-vote button').prop('disabled', false);
        });
    }
    

    if ($('.wp-block-ressources-vote').length > 0) {

        $('#comment-form').on(
            'submit',
            function () {

                var id_comment_parent = 'comment_ressource_parent';
                var route_vote = 'experts';
                if ($(this).hasClass('comment-form-expert-pending')) {
                    id_comment_parent = 'comment_expert_pending_parent';
                    route_vote = 'experts_pending';
                }


                var comment_parent = $('#' + id_comment_parent).val()

                var data = {
                    id: $("[data-id_vote]").data('id_vote'),
                    vote: 0,// simple message
                    comment: $('#comment').val(),
                };
                if ('' != comment_parent) {
                    data.comment_parent = comment_parent;
                }
                ajax_vote(data, route_vote);
                $('#comment').val('');
                $('#' + id_comment_parent).val('');

                return false;
            }
        );

        $('.single-ressource .wp-block-comment-form, .page-template-template-follow-requests-new-expert .wp-block-comment-form').parent('div').on(
            'click',
            '.comment-reply',
            function (e) {
                e.preventDefault();
                var comment_parent = $(this).data('reply');

                $('html, body').animate(
                    {
                        scrollTop: $("#comment-form").offset().top - 100
                    },
                    200
                );


                var id_comment_parent = 'comment_ressource_parent';

                if ($('.page-template-template-follow-requests-new-expert').length > 0) {
                    id_comment_parent = 'comment_expert_pending_parent';
                }

                $('#' + id_comment_parent).val(comment_parent);

            }
        );

        var dialogGood = document.getElementById('dialogGood');
        var dialogNotGood = document.getElementById('dialogNotGood');
        $('.wp-block-ressources-vote').on(
            'click',
            '#vote_good button, #vote_notgood button',
            function (e) {
                e.preventDefault();
                var divParent = $(this).parent('.is-style-vote');
                if ('vote_good' == $(divParent).attr('id')) {
                    dialogGood.showModal();
                } else {
                    dialogNotGood.showModal();
                }
            }
        );

        $('.comment-form-vote').on(
            'submit',
            function () {
                var comment = $(this).parent('dialog').find('textarea').val();
                var vote = 2;// vote contre
                if ('dialogGood' == $(this).parent('dialog').attr('id')) {
                    vote = 1;// vote pour
                }

                if (2 == vote && '' == comment) {
                    if ($('#comment-error').length == 0) {
                        $('<div id="comment-error" class="comment-error">Ce champ est obligatoire</div>').insertAfter($(this).parent('dialog').find('textarea'));
                    }
                    return false;
                }

                if ($(this).hasClass('comment-form-expert-pending')) {
                    // find in $(this) textarea name comment-vote and check if empty
                    if ('' == $(this).find('textarea[name="comment-vote"]').val()) {
                        if ($('#comment-error').length == 0) {
                            $('<div id="comment-error" class="comment-error">Ce champ est obligatoire</div>').insertAfter($(this).parent('dialog').find('textarea'));
                        }
                        return false;
                    }
                }


                $('#comment-error').remove();

                var data = {
                    id: $("[data-id_vote]").data('id_vote'),
                    vote: vote,// 1 vote pour / 2 vote contre
                    comment: comment,
                };

                var route_vote = 'experts';
                if ($(this).hasClass('comment-form-expert-pending')) {
                    route_vote = 'experts_pending';
                }

                ajax_vote(data, route_vote);

                $(this).parent('dialog').find('textarea').val('');

                $(this).parent('dialog').find('.btn-close').click();
                return false;
            }
        );
    }

    // filter works experts
    if ($('.page-template-template-expert_works').length > 0) {
        function ajaxWorks(paged) {
            var territoires = $('#orderby-select-territory').val();
            var thematiques = $('#orderby-select-theme').val();
            var myworks = $('#travaux:checked').val();
            myworks = typeof myworks != undefined ? myworks : 0;

            $('.wp-block-works').html($(wpBlockLoader));

            var data = {
                paged: paged,
                tax: {
                    territoires: territoires,
                    thematiques: thematiques
                },
                myworks: myworks,
                base: window.location.origin + window.location.pathname
            };
            $.ajax(
                {
                    url: OMBREE_INFO.api_url + '/works/experts',
                    type: "POST",
                    contentType: "application/json",
                    data: JSON.stringify(data),
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
                    },
                }
            ).done(
                function (response) {
                    if (response.html != null) {
                        $('.wp-block-works').css('display', 'block');
                        $('.wp-block-works').html(response.html);
                    } else {
                        $('.wp-block-works').css('display', 'none');
                    }
                    if (response.html_error != null) {
                        $('.noresults-message').css('display', 'block');
                        $('.noresults-message').html(response.html_error);
                    } else {
                        $('.noresults-message').css('display', 'none');
                    }
                    if (response.hasOwnProperty('pagi')) {
                        $('.pagination').remove();
                        $('.wp-block-works').after(response.pagi);
                    }
                }
            ).always(
                function () {
                    $('.wp-block-loader').remove();
                }
            );
        }

        $('.page-template-template-expert_works .container__1325').on(
            'click',
            '#works_submit',
            function () {
                ajaxWorks(1);

                return false;
            }
        );

        $('.page-template-template-expert_works .container__1325').on(
            'click',
            'a.page-numbers',
            function (e) {
                e.preventDefault();
                var paged = $(this).attr('href').split('page/');

                paged = $(paged).get(-1).match(/\d+/); // on récupère le dernier élément du tableau et uniquement les chiffres

                paged = paged != null ? paged[0] : 1;

                ajaxWorks(paged);

            }
        );

        function clean_url_flash_message() {
            var uri = window.location.toString();
            var clean_uri = uri.replace('?updated=1', '');
            window.history.replaceState({}, document.title, clean_uri);
            $('.flash_message').remove();
        }

        //Ajouter un post travaux
        $('.page-template-template-expert_works .container__1325').on(
            'click',
            '.is-style-add',
            function (event) {
                event.preventDefault();
                $('.wp-block-edit-post').hide();
                $('.wp-block-add-post').slideToggle();
                clean_url_flash_message();

            }
        );

        //Éditer un post travaux
        $('.page-template-template-expert_works .container__1325').on(
            'click',
            '.is-style-edit',
            function (event) {
                event.preventDefault();
                $('.wp-block-works').before($(wpBlockLoader));
                $('.wp-block-add-post').hide();
                $.ajax(
                    {
                        url: OMBREE_INFO.api_url + '/works/experts/update',
                        type: "POST",
                        contentType: "application/json",
                        data: JSON.stringify({
                            id: $(this).data('postid'),
                        }),
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
                        },
                    }
                ).done(
                    function (response) {
                        $('.update-work').html(response.html);
                        $('.wp-block-edit-post').show();
                    }
                ).always(
                    function () {
                        $('.wp-block-loader').remove();
                        $('html,body').animate({scrollTop: $('#wp-block-edit-post').offset().top + (-20)}, 300);
                    }
                );
            }
        );

        //Fermer ajouter/éditer un post travaux
        $('.page-template-template-expert_works .container__1325').on(
            'click',
            '.is-style-close.close-add',
            function (event) {
                event.preventDefault();
                $('.update-work').html('');
                $('.wp-block-add-post').slideToggle();
                clean_url_flash_message();
            }
        );
        $('.page-template-template-expert_works .container__1325').on(
            'click',
            '.is-style-close.close-edit',
            function (event) {
                event.preventDefault();
                $('.update-work').html('');
                $('.wp-block-edit-post').slideToggle();
                clean_url_flash_message();
            }
        );

        // delete work
        $('.page-template-template-expert_works .container__1325').on(
            'click',
            '.is-style-delete',
            function (event) {
                event.preventDefault();
                if (window.confirm('Voulez-vous vraiment supprimer ce travaux ?')) {
                    $('.wp-block-works').before($(wpBlockLoader));
                    $.ajax(
                        {
                            url: OMBREE_INFO.api_url + '/works/experts/delete',
                            type: "POST",
                            contentType: "application/json",
                            data: JSON.stringify({
                                id: $(this).data('postid'),
                            }),
                            beforeSend: function (xhr) {
                                xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
                            },
                        }
                    ).done(
                        function (response) {
                            window.location.reload();
                        }
                    );
                }
            }
        );
    }

})(jQuery);